import React from "react";
import LoginForm from "./LoginForm";
import AuthLayout from "../components/AuthLayout";

const Login: React.FC = () => {
  return (
    <AuthLayout title="Welcome back" subtitle="Please sign in to your account">
      <LoginForm />
    </AuthLayout>
  );
};

export default Login;
